import { Row } from "components/atoms/row";
import { ProfileCard } from "containers/my-profile/profile-card";
import { authActions, authAsync, authSelectors } from "core/store/modules/auth";
import { Dispatch, RootState } from "core/store/store.types";
import { User } from "core/types/user.types";
import { FunctionComponent, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Text } from "components/atoms/text";
import { Col } from "components/atoms/col";
import { UserStats } from "containers/my-profile/user-stats";
import { Grid } from "@mui/material";
import PricingPlan from "containers/pricing-plan/pricing-plan";
import { LoadingOverlay } from "components/atoms/loading-overlay";
import { SubscriptionPlan } from "containers/my-profile/subscription-plan";
import { UserSubStats } from "containers/my-profile/user-sub-stats";

interface OwnProps {}
interface StateProps {
  isAuthLoading: boolean;
  user?: User;
}
interface DispatchProps {
  getUser: () => void;
  resetUser: () => void;
}
export type Props = OwnProps & StateProps & DispatchProps;

const MyProfile: FunctionComponent<Props> = ({
  isAuthLoading,
  user,
  getUser,
  resetUser,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    getUser();
  }, []);

  console.log(user?.subscriptions?.status !== "canceled");

  return (
    <>
      {isAuthLoading && <LoadingOverlay open={isAuthLoading} />}
      <div style={{}}>
        <Text fontSize={"25px"} fontWeight={"700"} paddingBottom={"20px"}>
          {t("profile.title")}
        </Text>
        <Row container spacing={2} justifyContent={"center"}>
          <Col item xs={12} sm={4}>
            <Row>{user && user?.billingInfo && <UserStats user={user} />}</Row>
            <Row mt={user?.billingInfo ? "10px" : "0px"}>
              {user &&
                user.subscriptions &&
                user?.subscriptions?.status !== "canceled" && (
                  <UserSubStats
                    user={user}
                    updateProfile={() => {
                      resetUser();
                      getUser();
                    }}
                  />
                )}
            </Row>
          </Col>
          <Col item xs={12} sm={8}>
            {user && <ProfileCard user={user} />}
          </Col>
        </Row>
        {/* <Grid item container xs={12} sx={{ zIndex: 2 }}>
          <PricingPlan />
        </Grid> */}
        <Grid container>
          <SubscriptionPlan />
        </Grid>
      </div>
    </>
  );
};

export default connect<StateProps, DispatchProps, OwnProps, RootState>(
  (state: RootState) => ({
    isAuthLoading: authSelectors.isAuthLoading(state),
    user: authSelectors.getUser(state),
  }),
  (dispatch: Dispatch) => ({
    getUser: () => dispatch(authAsync.getUser()),
    resetUser: () => dispatch(authActions.resetAuth()),
  })
)(MyProfile);
